module.exports = __webpack_public_path__ + "img/vertical_mid_frame_top.25744c84.png";